(function () {
  if (window.__kwWystawa) return;
  window.__kwWystawa = true;

  function setOpen(box, open) {
    var btn = box.querySelector('.kw-more__btn');
    var body = box.querySelector('.kw-more__body');
    var close = box.querySelector('.kw-more__close');
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('span').textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    if (open) {
      body.removeAttribute('hidden');
    } else {
      try { body.setAttribute('hidden', 'until-found'); } catch (e) { body.hidden = true; }
    }
    if (close) close.hidden = !open;
  }

  function initMore(root) {
    var boxes = (root || document).querySelectorAll('[data-kw-more]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.getAttribute('data-ready')) continue;
      box.setAttribute('data-ready', '1');
      var btn = box.querySelector('.kw-more__btn');
      var body = box.querySelector('.kw-more__body');
      var close = box.querySelector('.kw-more__close');
      if (!btn || !body) continue;
      btn.hidden = false;
      btn.setAttribute('aria-controls', body.id);
      setOpen(box, false);
      (function (box, btn, body, close) {
        btn.addEventListener('click', function () {
          setOpen(box, !box.classList.contains('is-open'));
        });
        if (close) {
          close.addEventListener('click', function () {
            setOpen(box, false);
            btn.focus({ preventScroll: true });
            var top = btn.getBoundingClientRect().top;
            if (top < 80 || top > window.innerHeight) {
              btn.scrollIntoView({ block: 'center' });
            }
          });
        }
        body.addEventListener('beforematch', function () { setOpen(box, true); });
      })(box, btn, body, close);
    }
  }

  function openForHash() {
    if (!location.hash || location.hash.length < 2) return;
    var el;
    try { el = document.querySelector(location.hash); } catch (e) { return; }
    if (!el) return;
    var box = el.closest ? el.closest('[data-kw-more]') : null;
    if (box && !box.classList.contains('is-open')) {
      setOpen(box, true);
      el.scrollIntoView();
    }
  }

  function initToc() {
    var btns = document.querySelectorAll('.kw-totop');
    if (btns.length) {
      document.documentElement.classList.add('js-kw');
      var nav = document.getElementById('spis');
      var onScroll = function () {
        var limit = nav ? nav.getBoundingClientRect().bottom + window.scrollY + 400 : 700;
        for (var k = 0; k < btns.length; k++) btns[k].classList.toggle('is-visible', window.scrollY > limit);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var links = document.querySelectorAll('a[data-kw-toc-open]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        var toc = document.getElementById('spis-plansz');
        if (toc && toc.tagName === 'DETAILS') toc.open = true;
      });
    }
  }

  function init() {
    initMore(document);
    initToc();
    openForHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('hashchange', openForHash);
  document.addEventListener('shopify:section:load', function (e) { initMore(e.target); });
})();